"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChooseFamily = void 0;
var legup_model_1 = require("@legup/legup-model");
var react_1 = __importDefault(require("react"));
var Divider_1 = __importDefault(require("@material-ui/core/Divider"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var styles_1 = require("@material-ui/core/styles");
var LimitTextField_1 = require("../common/LimitTextField");
var PhoneNumbers_1 = require("../common/PhoneNumbers");
var strings_1 = __importDefault(require("../strings"));
var ChildForm_1 = require("./ChildForm");
var useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        divider: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            height: 2,
        },
    });
});
var ChooseFamily = function (props) {
    var classes = useStyles(props);
    var _a = react_1.default.useState(props.parent ? props.parent.copy() : new legup_model_1.Parent()), parent = _a[0], setParent = _a[1];
    var _b = react_1.default.useState(props.child ? props.child.copy() : new legup_model_1.Child()), child = _b[0], setChild = _b[1];
    react_1.default.useEffect(function () {
        setParent(props.parent ? props.parent.copy() : new legup_model_1.Parent());
    }, [props.parent]);
    react_1.default.useEffect(function () {
        setChild(props.child ? props.child.copy() : new legup_model_1.Child());
    }, [props.child]);
    var onSetParentFirstName = function (e) {
        var newParent = parent.copy();
        newParent.setFirstName(e.target.value);
        setParent(newParent);
        props.onChange(newParent, child);
    };
    var onFormatParentFirstName = function (e) {
        var newParent = parent.copy();
        newParent.setFirstName(e.target.value.trim());
        setParent(newParent);
        props.onChange(newParent, child);
    };
    var onSetParentLastName = function (e) {
        var newParent = parent.copy();
        newParent.setLastName(e.target.value);
        setParent(newParent);
        props.onChange(newParent, child);
    };
    var onFormatParentLastName = function (e) {
        var newParent = parent.copy();
        newParent.setLastName(e.target.value.trim());
        setParent(newParent);
        props.onChange(newParent, child);
    };
    var onSetParentEmail = function (e) {
        var newParent = parent.copy();
        newParent.setEmail(e.target.value);
        setParent(newParent);
        props.onChange(newParent, child);
    };
    var onFormatParentEmail = function (e) {
        var newParent = parent.copy();
        newParent.setEmail(e.target.value.trim());
        setParent(newParent);
        props.onChange(newParent, child);
    };
    var onChangePhoneNumbers = function (home_phone_number, work_phone_number, cell_phone_number, can_text, primary_phone) {
        var newParent = parent.copy();
        newParent.setPhoneNumber(home_phone_number);
        newParent.setWorkPhoneNumber(work_phone_number);
        newParent.setCellPhoneNumber(cell_phone_number);
        newParent.setCanText(can_text);
        newParent.setPrimaryPhone(primary_phone);
        setParent(newParent);
        props.onChange(newParent, child);
    };
    var onChangeChild = function (c, field) {
        var newChild = c.copy();
        setChild(newChild);
        props.onChange(parent, newChild);
    };
    var errorParentFirstName = false;
    var errorParentLastName = false;
    var errorEmail = false;
    var errorPhone = false;
    if (props.showErrors) {
        if (!parent.first_name) {
            errorParentFirstName = true;
        }
        if (!parent.last_name) {
            errorParentLastName = true;
        }
        if (!parent.email) {
            errorEmail = true;
        }
        if (!parent.phone_number && !parent.work_phone_number && !parent.cell_phone_number) {
            errorPhone = true;
        }
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Grid_1.default, { container: true, spacing: 2, style: { marginTop: "32px" } },
            react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                react_1.default.createElement(LimitTextField_1.LimitTextField, { error: errorParentFirstName, key: "parent_first_name", name: "first_name", variant: "outlined", size: "small", fullWidth: true, label: strings_1.default.chooseFamily.parentFirstName, value: parent.getFirstName() || "", limit: 128, showCount: false, disabled: props.readOnly, onChange: onSetParentFirstName, onBlur: onFormatParentFirstName })),
            react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                react_1.default.createElement(LimitTextField_1.LimitTextField, { error: errorParentLastName, key: "parent_last_name", name: "last_name", variant: "outlined", size: "small", fullWidth: true, label: strings_1.default.chooseFamily.parentLastName, value: parent.getLastName() || "", limit: 128, showCount: false, disabled: props.readOnly, onChange: onSetParentLastName, onBlur: onFormatParentLastName })),
            react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                react_1.default.createElement(LimitTextField_1.LimitTextField, { error: errorEmail, key: "parent_email", name: "email", variant: "outlined", size: "small", fullWidth: true, label: strings_1.default.chooseFamily.email, value: parent.getEmail() || "", limit: 128, showCount: false, disabled: props.readOnly, onChange: onSetParentEmail, onBlur: onFormatParentEmail }),
                react_1.default.createElement("div", { style: { color: "Red" } }, props.emailValidationError ? strings_1.default.errorMessages.emailValidationError : null)),
            props.showPhoneNumber ? react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                react_1.default.createElement(PhoneNumbers_1.PhoneNumbers, { error: errorPhone, name: "choose_family", phone_number: parent.getPhoneNumber() || "", work_phone_number: parent.getWorkPhoneNumber() || "", cell_phone_number: parent.getCellPhoneNumber() || "", can_text: parent.getCanText(), primary_phone: parent.getPrimaryPhone(), showPrimary: !props.phoneDisplay || (props.phoneDisplay.length > 1), readOnly: props.readOnly, display: props.phoneDisplay || ["home", "work", "cell"], onChange: onChangePhoneNumbers })) : null),
        react_1.default.createElement(Divider_1.default, { variant: "fullWidth", className: classes.divider }),
        react_1.default.createElement(ChildForm_1.ChildForm, { child: child, noAddress: true, readOnly: props.readOnly, disallowOther: props.disallowOther, onChange: onChangeChild })));
};
exports.ChooseFamily = ChooseFamily;
